import { call, put } from 'redux-saga/effects';

import {
  createSettingPriceRequest,
  updateSettingPriceRequest,
  fetchSettingPricesRequest,
} from '../requests';
import { createSettingPrice, updateSettingPrice } from '../../../actions';

export function* createSettingPriceService(data) {
  yield put(createSettingPrice(data));

  const { success } = yield call(createSettingPriceRequest, data);

  if (success) {
    yield call(fetchSettingPricesRequest);
  }
}

export function* updateSettingPriceService(id, data) {
  yield put(updateSettingPrice(id, data));
  yield call(updateSettingPriceRequest, id, data);
}
